<style lang="scss" scoped>
.img-upload {
  width: 100%;
  @include flex-row;
  .demo-img {
    width: 76px;
    height: 76px;
    border-radius: 4px;
    position: relative;
    .text {
      position: absolute;
      top: 4px;
      left: 4px;
      width: 32px;
      height: 16px;
      background: #15bb5c;
      border-radius: 4px;
      @include text(12px, #fff);
      @include flex-row-center;
    }
    .img {
      width: 76px;
      height: 76px;
      border-radius: 4px;
      overflow: hidden;
    }
  }
  .pic-item {
    width: 76px;
    height: 76px;
    margin-left: 13px;
    position: relative;
    .img-pic {
      width: 76px;
      height: 76px;
      border-radius: 4px;
    }
    .close-btn {
      position: absolute;
      top: -10px;
      right: -10px;
      padding: 4px;
      z-index: 9;
      .close-icon {
        width: 16px;
        height: 16px;
      }
    }
  }
  .camera-img {
    width: 76px;
    height: 76px;
    border: 1px dashed #f5f5f5;
    box-sizing: border-box;
    margin-left: 13px;
    border-radius: 4px;
    @include flex-column-center;
    .img-camera {
      width: 28px;
      height: 28px;
    }
    .text {
      margin-top: 4px;
      @include text(12px, #262626);
    }
  }
}

.file-uploader {
  display: none;
}
</style>

<template>
  <div class="img-upload">
    <div class="demo-img">
      <div class="text">示例</div>
      <img class="img" src="@/images/key_box/demo.jpg" />
    </div>
    <div
      v-for="(pic, index) in pics"
      :key="pic.fileId"
      class="pic-item"
      :class="{
        'show-img': pic.fileUrl
      }"
    >
      <img
        v-if="pic.fileUrl"
        :src="adaptOssImage(pic.fileUrl, resl)"
        class="img-pic"
        @error="imgLoadFail"
        @click.stop="previewImg(pic.fileUrl)"
      />
      <div v-show="pic.fileUrl" class="close-btn" @click.stop="delPhoto(index)">
        <img src="@/images/key_box/icon_wrong.png" class="close-icon" />
      </div>
    </div>
    <div v-if="pics.length < maxLength" class="camera-img" @click="addPhoto">
      <img src="@/images/market_research/icon_camera.png" class="img-camera" />
      <span class="text">添加图片</span>
    </div>
    <input
      ref="uploader"
      type="file"
      class="file-uploader"
      accept="image/*"
      @change="onFileChange"
    />
  </div>
</template>

<script>
import { ossImage, imgLoadFail, onLoadP } from '@/utils/oss_image'

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['ossData'],
  data() {
    return {
      pics: [],
      resl: 440,
      maxLength: 3
    }
  },
  methods: {
    imgLoadFail,
    adaptOssImage(src, width = 0, height = 0) {
      return ossImage({
        src,
        width,
        height
      })
    },
    async onFileChange(e) {
      const file = e.target.files[0]

      if (file) {
        this.$Loading()
        const ossData = this.ossData
        try {
          const data = await onLoadP({
            ossData,
            file,
            path: ''
          })

          this.updateImg(data)
          this.$Loading.hide()
        } catch (error) {
          this.$Loading.hide()
          if (error.message) {
            this.$toast(error.message)
          } else if (
            'status' in error &&
            'headers' in error &&
            'body' in error &&
            error.status === 413
          ) {
            this.$toast('图片尺寸过大，上传失败')
          } else {
            console.log(error, 'error==>>')
            this.$catch(error)
          }
        }
      }
    },
    updateImg(img) {
      const pic = img.data
      const currPic = {
        fileId: '/' + pic.fid,
        fileUrl: pic.furl
      }
      this.pics.push(currPic)
      this.updateFile()
    },
    addPhoto(item, index) {
      this.$refs.uploader.click()
    },
    delPhoto(index) {
      const images = this.pics
      images.splice(index, 1)
      this.pics = images
      this.updateFile()
    },
    updateFile() {
      this.$nextTick(() => {
        if (this.$refs.uploader) {
          this.$refs.uploader.value = ''
        }

        this.$emit(
          'update:pics',
          this.pics.filter(pic => pic.fileId).map(pic => pic.fileId)
        )
      })
    },
    previewImg(img) {
      this.$emit('previewImg', img)
    }
  }
}
</script>
